import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../common/Modal';

const BrandPromoModal = ({ close }) => (
  <Modal title="use a different name" close={close} showCloseButton>
    <div className="u-mv u-ph+ u-margin-auto u-max-width-600">
      A promo code with the same name already exists on the brand level and has been assigned to this location.
      To create a location specific name please use a different PROMO name.
    </div>
  </Modal>
);

BrandPromoModal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default BrandPromoModal;
